import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { getMonSumTableApi, getDaysTableApi, getDaysChartApi, getYearSumTableApi, getMonthsTableApi, getMonthsChartApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';
import { isDateAfterToday } from '@/utils/datetime';

import { DateTime } from 'luxon';
import downloadCsv from 'download-csv';
export default {
  name: 'MonthlyReport',
  data: function data() {
    return {
      tableAccObj: {
        kWh: 0,
        peakWatt: 0,
        IRR: 0,
        PR: 0
      },
      tableAvgObj: {
        kWh: 0,
        peakWatt: 0,
        IRR: 0,
        PR: 0
      },
      sumTableObj: {
        accIRR: '-',
        peakWatt: '-',
        accKwh: '-',
        accPR: {
          all: '-'
        }
      },
      tableData: [],
      chartData: [],
      datepickerDate: DateTime.local().minus({
        months: 1
      }).toFormat('yyyy-MM'),
      selectedTime: 'month',
      searchedTime: '月',
      monthsChart: {
        chart: {
          height: 350,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: []
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '發電量 (kWh)'
          }
        }, {
          title: {
            text: '日照量 (kWh/m²)'
          },
          opposite: true
        }, {
          title: {
            text: '發電效率 (%)'
          },
          opposite: true,
          min: 0
        }],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        labels: {},
        tooltip: {
          shared: true
        },
        series: [{
          type: 'column',
          name: '發電量 (kWh)',
          data: [],
          yAxis: 0
        }, {
          type: 'line',
          name: '日照量 (kWh/m²)',
          data: [],
          yAxis: 1
        }, {
          type: 'line',
          name: '發電效率 (%)',
          data: [],
          yAxis: 2
        }]
      }
    };
  },
  computed: {
    timeFormat: function timeFormat() {
      return this.selectedTime === 'month' ? 'YYYY-MM' : 'YYYY';
    },
    timeToText: function timeToText() {
      return this.selectedTime === 'month' ? '月' : '年';
    }
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    dbDataHandle: dbDataHandle,
    handleSelectTime: function handleSelectTime(time) {
      this.selectedTime = time;
      this.datepickerDate = time === 'month' ? DateTime.local().minus({
        months: 1
      }).toFormat('yyyy-MM') : DateTime.local().minus({
        year: 1
      }).toFormat('yyyy');
    },
    getSearch: function getSearch(time) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(time === 'month')) {
                  _context.next = 6;
                  break;
                }
                _context.next = 3;
                return Promise.all([_this.getMonthSumData(), _this.getDaysTableData(), _this.getDaysChartData()]);
              case 3:
                _this.searchedTime = '月';
                _context.next = 9;
                break;
              case 6:
                _context.next = 8;
                return Promise.all([_this.getYearSumData(), _this.getMonthsTableData(), _this.getMonthsChartData()]);
              case 8:
                _this.searchedTime = '年';
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMonthSumData: function getMonthSumData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _monSumTable$data;
        var monSumTable;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getMonSumTableApi(_this2.$route.query.fid, _this2.datepickerDate);
              case 2:
                monSumTable = _context2.sent;
                if (monSumTable !== null && monSumTable !== void 0 && (_monSumTable$data = monSumTable.data) !== null && _monSumTable$data !== void 0 && _monSumTable$data.success) {
                  _this2.sumTableObj = monSumTable.data.data;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getDaysTableData: function getDaysTableData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _tableData$data;
        var tableData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getDaysTableApi(_this3.$route.query.fid, _this3.datepickerDate);
              case 2:
                tableData = _context3.sent;
                if (tableData !== null && tableData !== void 0 && (_tableData$data = tableData.data) !== null && _tableData$data !== void 0 && _tableData$data.success) {
                  _this3.tableData = tableData.data.data;
                  _this3.calculateTableData();
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getDaysChartData: function getDaysChartData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _dayschart$data;
        var dayschart;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getDaysChartApi(_this4.$route.query.fid, _this4.datepickerDate);
              case 2:
                dayschart = _context4.sent;
                if (dayschart !== null && dayschart !== void 0 && (_dayschart$data = dayschart.data) !== null && _dayschart$data !== void 0 && _dayschart$data.success) {
                  _this4.chartData = dayschart.data.data;
                  _this4.drawChart();
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getYearSumData: function getYearSumData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _yearSumTable$data;
        var yearSumTable;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getYearSumTableApi(_this5.$route.query.fid, _this5.datepickerDate);
              case 2:
                yearSumTable = _context5.sent;
                if (yearSumTable !== null && yearSumTable !== void 0 && (_yearSumTable$data = yearSumTable.data) !== null && _yearSumTable$data !== void 0 && _yearSumTable$data.success) {
                  _this5.sumTableObj = yearSumTable.data.data;
                }
              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getMonthsTableData: function getMonthsTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _monthsTable$data;
        var monthsTable;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return getMonthsTableApi(_this6.$route.query.fid, _this6.datepickerDate);
              case 2:
                monthsTable = _context6.sent;
                if (monthsTable !== null && monthsTable !== void 0 && (_monthsTable$data = monthsTable.data) !== null && _monthsTable$data !== void 0 && _monthsTable$data.success) {
                  _this6.tableData = monthsTable.data.data;
                  _this6.calculateTableData();
                }
              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getMonthsChartData: function getMonthsChartData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _monthsChart$data;
        var monthsChart;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return getMonthsChartApi(_this7.$route.query.fid, _this7.datepickerDate);
              case 2:
                monthsChart = _context7.sent;
                if (monthsChart !== null && monthsChart !== void 0 && (_monthsChart$data = monthsChart.data) !== null && _monthsChart$data !== void 0 && _monthsChart$data.success) {
                  _this7.chartData = monthsChart.data.data;
                  _this7.drawChart();
                }
              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    calculateTableData: function calculateTableData() {
      var _this8 = this;
      this.tableAccObj = {
        kWh: 0,
        peakWatt: 0,
        IRR: 0,
        PR: 0
      };
      this.tableAvgObj = {
        kWh: 0,
        peakWatt: 0,
        IRR: 0,
        PR: 0
      };
      this.tableData.forEach(function (x, idx) {
        if (x.accKwh) {
          _this8.tableAccObj.kWh = dbDataHandle(_this8.tableAccObj.kWh + x.accKwh);
        }
        if (x.peakWatt) {
          _this8.tableAccObj.peakWatt = dbDataHandle(_this8.tableAccObj.peakWatt + x.peakWatt);
        }
        if (x.accIRR) {
          _this8.tableAccObj.IRR = dbDataHandle(_this8.tableAccObj.IRR + x.accIRR);
        }
        if (x.accPR) {
          _this8.tableAccObj.PR = dbDataHandle(_this8.tableAccObj.PR + x.accPR);
        }
        if (idx === _this8.tableData.length - 1) {
          _this8.tableAvgObj.kWh = dbDataHandle(_this8.tableAccObj.kWh / _this8.tableData.length);
          _this8.tableAvgObj.peakWatt = dbDataHandle(_this8.tableAccObj.peakWatt / _this8.tableData.length);
          _this8.tableAvgObj.IRR = dbDataHandle(_this8.tableAccObj.IRR / _this8.tableData.length);
          _this8.tableAvgObj.PR = dbDataHandle(_this8.tableAccObj.PR / _this8.tableData.length * 100);
        }
      });
    },
    downloadData: function downloadData() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.monthsChart.xAxis.categories);
      this.monthsChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.monthsChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.chartData.forEach(function (obj) {
        download[0].data.push(obj.accKwh);
        download[1].data.push(obj.accIRR);
        download[2].data.push(obj.accPR * 100);
      });
      this.monthsChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      var fileName = "\u6848\u5834\u5831\u8868_".concat(this.datepickerDate);
      downloadCsv(downloadArr, fields, fileName);
    },
    drawChart: function drawChart() {
      var _this9 = this;
      this.monthsChart.xAxis.categories = [];
      this.monthsChart.series.forEach(function (x) {
        x.data = [];
      });
      this.chartData.forEach(function (x) {
        _this9.monthsChart.xAxis.categories.push(x.date);
        _this9.monthsChart.series[0].data.push(dbDataHandle(x.accKwh));
        _this9.monthsChart.series[1].data.push(dbDataHandle(x.accIRR));
        _this9.monthsChart.series[2].data.push(dbDataHandle(x.accPR * 100));
      });
      this.$nextTick(function () {
        this.$refs.chart.chart.hideLoading();
      });
    }
  },
  watch: {},
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  mounted: function mounted() {
    var _this10 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this10.getSearch('month');
            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  }
};